module.exports = __webpack_public_path__ + "static/media/07-Model-15.9bd69d90.webp";